import { render } from "./carouselFeldlisten.vue?vue&type=template&id=fbbd484a"
import script from "./carouselFeldlisten.vue?vue&type=script&lang=js"
export * from "./carouselFeldlisten.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__